var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451,
    height: 411,
    viewBox: "0 0 451 411",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_91_30909)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.604 155.383L158.954 137.613C148.558 151.609 139.628 166.64 132.305 182.471L108.604 155.383ZM73.6197 158.301L120.267 211.612L113.51 228.504C111.412 233.75 112.642 239.742 116.637 243.738L121.067 248.167C97.0107 275.293 83.723 303.663 70.8498 342.284C69.1579 347.359 70.4789 352.955 74.2619 356.738C78.0452 360.52 83.641 361.843 88.7166 360.15C127.336 347.277 155.707 333.989 182.832 309.933L187.262 314.363C191.257 318.359 197.249 319.588 202.496 317.49L219.388 310.733L272.699 357.38C276.224 360.465 281.049 361.601 285.581 360.413C290.113 359.225 293.76 355.869 295.32 351.451L337.498 231.945C365.305 199.042 380.875 157.119 380.875 113.416V64.25C380.875 56.449 374.551 50.125 366.75 50.125H317.584C273.881 50.125 231.958 65.6943 199.055 93.5015L79.5488 135.68C75.1313 137.239 71.7741 140.887 70.5865 145.419C69.3987 149.95 70.5349 154.776 73.6197 158.301ZM108.054 322.945C116.918 301.539 126.865 284.5 141.083 268.184L162.816 289.917C146.501 304.135 129.462 314.082 108.054 322.945ZM200.651 287.801L193.113 280.262L150.738 237.887L143.199 230.349L153.226 205.28C162.427 182.278 175.347 160.945 191.47 142.135L199.614 132.633C229.133 98.1951 272.225 78.375 317.584 78.375H352.625V113.416C352.625 158.774 332.805 201.867 298.367 231.385L288.865 239.53C270.054 255.652 248.721 268.572 225.72 277.773L200.651 287.801ZM275.617 322.396L248.529 298.695C264.361 291.373 279.391 282.442 293.387 272.046L275.617 322.396ZM267.875 149C267.875 141.199 274.199 134.875 282 134.875C289.801 134.875 296.125 141.199 296.125 149C296.125 156.801 289.801 163.125 282 163.125C274.199 163.125 267.875 156.801 267.875 149ZM282 106.625C258.596 106.625 239.625 125.597 239.625 149C239.625 172.403 258.596 191.375 282 191.375C305.404 191.375 324.375 172.403 324.375 149C324.375 125.597 305.404 106.625 282 106.625Z",
    fill: "#FFEAE7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_91_30909",
    x: 51.0558,
    y: 31.0563,
    width: 348.888,
    height: 348.888,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.53437
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.15 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_30909"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_30909",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3D);
export default __webpack_public_path__ + "static/media/step3d.38d8edc68e06c474bc63224880d79c29.svg";
export { ForwardRef as ReactComponent };